import { useEffect, useState } from "react";
import "./index.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { load } from "@cashfreepayments/cashfree-js";
import { useRazorpay } from "react-razorpay";
import { initializeCashfree } from "../../gateway/cashfree";

const MultiPayment = () => {
  // const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  // const userDetails = JSON.parse(localStorage.getItem("address"));
  // const { Razorpay } = useRazorpay();
  // const [isPaytmReady, setIsPaytmReady] = useState(false);

  // useEffect(() => {
  //   if (process.env.REACT_APP_PAYMENT_TYPE === "paytm") {
  //     if (isPaytmReady) {
  //       payNow();
  //     }
  //   } else {
  //     payNow();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [searchParams, isPaytmReady]);


  // const PhonePePayment = async () => {
  //   const data = {
  //     name: searchParams.get("name"),
  //     mobileNumber: searchParams.get("mobileno"),
  //     amount: searchParams.get("amount"),
  //     domainname: window.location.hostname,
  //   };

  //   try {
  //     setLoading(true);
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/phonepay/sdk/create-order`,
  //       data
  //     );

  //     if (res.data?.data?.instrumentResponse?.redirectInfo?.url) {
  //       window.open(res.data.data.instrumentResponse.redirectInfo.url, "_self");
  //     }
  //   } catch (error) {
  //     console.error("Error in payment:", error);
  //   } finally {
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 2000);
  //   }
  // };

  // const handleRazorpayPayment = async () => {
  //   try {
  //     const { data } = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/razorpay/create-order`,
  //       {
  //         domainname: searchParams.get("domainname"),
  //         amount: searchParams.get("amount"),
  //         currency: "INR",
  //         razorPayId: process.env.REACT_APP_RAZORPAY_KEY_ID,
  //         razorPayKeySecret: process.env.REACT_APP_RAZORPAY_KEY_SECRET,
  //       }
  //     );
  //     const domainname = searchParams.get("domainname");
  //     const options = {
  //       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
  //       amount: data.amount,
  //       currency: data.currency,
  //       name: window.location.hostname,
  //       description: "",
  //       image: process.env.REACT_APP_LOGO,
  //       order_id: data.id,
  //       handler: async (response) => {
  //         const redirectUrl = `https://${domainname}/payment-status?orderId=${encodeURIComponent(
  //           response.razorpay_order_id.replace("order_", "")
  //         )}&razorpay_order_id=${encodeURIComponent(response.razorpay_order_id)}&razorpay_payment_id=${encodeURIComponent(
  //           response.razorpay_payment_id
  //         )}&razorpay_signature=${encodeURIComponent(response.razorpay_signature)}&razorpay_secret=${encodeURIComponent(process.env.REACT_APP_RAZORPAY_KEY_SECRET)}`;

  //         window.location.href = redirectUrl;

  //       },
  //       prefill: {
  //         name: searchParams.get("name"),
  //         email: `support@${window.location.hostname}.com`,
  //         contact: searchParams.get("mobileno"),
  //       },
  //       notes: {
  //         address: userDetails.address1,
  //       },
  //       theme: {
  //         color: process.env.REACT_APP_THEAM_COLOR,
  //       },
  //       modal: {
  //         ondismiss: function () {
  //           window.location.href = `https://${domainname}/cart`
  //         },
  //       },
  //     };
  //     const razorpay = new Razorpay(options);
  //     razorpay.open();
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // const cashFreePayment = async () => {
  //   const cashfree = await initializeCashfree();
  //   if (!cashfree) {
  //     alert("Cashfree not configured properly.");
  //     setLoading(false);
  //     return;
  //   }
  //   const customerphone = `+91${searchParams.get("mobileno")}`;
  //   const data = {
  //     customername: searchParams.get("name"),
  //     customerphone: customerphone,
  //     domainname: searchParams.get("domainname"),
  //     amount: searchParams.get("amount"),
  //     cashfreeappid: process.env.REACT_APP_CASHFREE_APP_ID,
  //     cashfreesecretkey: process.env.REACT_APP_CASHFREE_SECRET_KEY,
  //   };

  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/cashfree/create-order`,
  //       data
  //     );

  //     if (!response.data.payment_session_id) {
  //       setLoading(false);
  //       console.error("Payment session ID not received");
  //       return;
  //     }

  //     setLoading(false);

  //     cashfree.checkout({
  //       paymentSessionId: response.data.payment_session_id,
  //       redirectTarget: "_self",
  //     });

  //     // Set timeout after opening Cashfree
  //     setTimeout(() => {
  //       setLoading(false);
  //       setTimeout(() => {
  //         window.location.href = `https://${searchParams.get(
  //           "domainname"
  //         )}/cart?paymentstatus=fail&name=${searchParams.get(
  //           "name"
  //         )}&mobileno=${searchParams.get("mobileno")}&amount=${searchParams.get(
  //           "amount"
  //         )}&domainname=${searchParams.get("domainname")}`;
  //       }, 100);
  //     }, 2000);
  //   } catch (error) {
  //     console.error("Error in payment:", error);
  //     setLoading(false);
  //   }
  // };

  // const IndianPayPayment = async () => {
  //   const customerphone = `+91${searchParams.get("mobileno")}`;
  //   const data = {
  //     name: searchParams.get("name"),
  //     mobile: customerphone,
  //     amount: searchParams.get("amount"),
  //     domainname: searchParams.get("domainname"),
  //     email: "",
  //     remark: "",
  //     type: "",
  //   };
  //   try {
  //     setLoading(true);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/pay/create-order`,
  //       data
  //     );
  //     setLoading(false);
  //     if (response.data?.payment_link) {
  //       window.open(response.data?.payment_link, "_self");
  //     }
  //   } catch (error) {
  //     console.error("Error in payment:", error);
  //     setLoading(false);
  //   } finally {
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 2000);
  //   }
  // };

  // const PayUPayPayment = async () => {
  //   const customerphone = `+91${searchParams.get("mobileno")}`;
  //   const data = {
  //     firstname: searchParams.get("name"),
  //     phone: customerphone,
  //     amount: searchParams.get("amount"),
  //     domainname: searchParams.get("domainname"),
  //     email: "test@gmail.com",
  //     productinfo: "Product Description",
  //   };
  //   try {
  //     setLoading(true);
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/payu/initiate-payment`,
  //       data
  //     );
  //     setLoading(false);
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(res.data, "text/html");
  //     const form = doc.querySelector("form");
  //     if (form) {
  //       document.body.appendChild(form);
  //       form.submit(); // 🚀 Redirects to PayU gateway
  //     } else {
  //       console.error("Form not found in PayU response.");
  //     }
  //   } catch (err) {
  //     console.error("Payment initiation failed:", err);
  //   } finally {
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 2000);
  //   }
  // };

  // // Paytm Integration
  // useEffect(() => {
  //   if (process.env.REACT_APP_PAYMENT_TYPE !== "paytm") return;
  //   const mid = process.env.REACT_APP_PAYTM_MID;
  //   if (!mid) {
  //     console.warn("⚠️ Paytm MID not found in environment variables — skipping Paytm SDK load");
  //     return;
  //   }
  //   const script = document.createElement("script");
  //   script.src = `https://secure.paytmpayments.com/merchantpgpui/checkoutjs/merchants/${mid}.js`;
  //   script.type = "application/javascript";
  //   script.async = true;

  //   script.onload = () => {
  //     // console.log("✅ Paytm SDK loaded");
  //     window.paytmReady = true; // mark flag
  //     setIsPaytmReady(true); // ✅ mark as ready
  //   };

  //   script.onerror = () => console.error("❌ Failed to load Paytm SDK");
  //   document.body.appendChild(script);

  //   return () => document.body.removeChild(script);
  // }, []);

  // const paytmPayment = async () => {
  //   const customerphone = `+91${searchParams.get("mobileno")}`;
  //   try {
  //     if (!window.paytmReady || !window.Paytm?.CheckoutJS) {
  //       alert("⚠️ Paytm SDK is still loading. Please try again in a moment.");
  //       return;
  //     }
  //     setLoading(true);

  //     const orderId = "ORDERID_" + new Date().getTime();
  //     const customerId = "CUST_" + new Date().getTime();
  //     const amount = searchParams.get("amount"); // Example amount
  //     const { data } = await axios.post(
  //       `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/paytm/create-order`,
  //       {
  //         amount,
  //         orderId,
  //         customerId,
  //         paytmmid: process.env.REACT_APP_PAYTM_MID,
  //         paytmkey: process.env.REACT_APP_PAYTM_KEY,
  //         domainname: searchParams.get("domainname"),
  //         name: searchParams.get("name"),
  //         mobile: customerphone,
  //       }
  //     );

  //     if (!data?.txnToken) throw new Error("Failed to get transaction token from server.");

  //     // Configure Paytm CheckoutJS
  //     const config = {
  //       root: "",
  //       flow: "DEFAULT",
  //       data: {
  //         orderId: data.orderId,
  //         token: data.txnToken,
  //         tokenType: "TXN_TOKEN",
  //         amount: data.amount,
  //         mid: data.mid,
  //         userInfo: {
  //           custId: customerId,
  //           firstName: searchParams.get("name"),
  //           mobile: customerphone,
  //         },
  //       },
  //       handler: {
  //         notifyMerchant: function (eventName, info) {
  //           console.log("🔔 Paytm Event:", eventName, info);

  //           // 👇 Detect close/back event and redirect
  //           if (eventName === "APP_CLOSED") {
  //             window.location.href = `https://${window.location.hostname}/cart`;
  //           }

  //         },
  //         transactionStatus: function (paymentStatus) {
  //           // console.log("🧾 Payment Status:", paymentStatus);
  //           // window.location.href = `https://${window.location.hostname}/payment-status?orderId=${data.orderId}`;
  //         },

  //       },
  //     };
  //     // console.log("🧩 Paytm SDK Object:", window.Paytm.CheckoutJS);

  //     window.Paytm.CheckoutJS.init(config)
  //       .then(() => {
  //         // console.log("✅ Paytm Checkout initialized");
  //         window.Paytm.CheckoutJS.invoke();
  //       })
  //       .catch((error) => {
  //         console.error("❌ Paytm init failed:", error);
  //       });
  //   } catch (error) {
  //     console.error("Payment Error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  // const payNow = async () => {
  //   if (process.env.REACT_APP_PAYMENT_TYPE === "cashfree") {
  //     cashFreePayment();
  //   } else if (process.env.REACT_APP_PAYMENT_TYPE === "razorpay") {
  //     handleRazorpayPayment();
  //   } else if (process.env.REACT_APP_PAYMENT_TYPE === "phonepe") {
  //     PhonePePayment();
  //   } else if (process.env.REACT_APP_PAYMENT_TYPE === "indianpay") {
  //     IndianPayPayment();
  //   } else if (process.env.REACT_APP_PAYMENT_TYPE === "payu") {
  //     PayUPayPayment();
  //   } else if (process.env.REACT_APP_PAYMENT_TYPE === "paytm") {
  //     paytmPayment();
  //   } else {
  //     setLoading(true);
  //   }
  // };

  return (
    <>
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spinner />
          <div>Please wait</div>
        </div>
      )}
    </>
  );
};

export default MultiPayment;
